import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MegaMenuModule } from 'primeng/megamenu';
import { CardModule } from 'primeng/card';
import { SharedModule as primeSharedModule } from 'primeng/api';
import { ReviewsComponent } from 'src/app/components/reviews/reviews.component';
import { MenubarModule } from 'primeng/menubar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RippleModule } from 'primeng/ripple';
import { FooterComponent } from './footer/footer.component';
import { DialogModule } from 'primeng/dialog';
import { CarouselModule } from 'primeng/carousel';
import { ImageModule } from 'primeng/image';
import { GalleriaModule } from 'primeng/galleria';

@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    CommonModule,
    InputTextModule,
    ButtonModule,
    MenubarModule,
    PanelMenuModule,
    MegaMenuModule,
    CardModule,
    primeSharedModule,
    RippleModule,
    DialogModule,
    CarouselModule,
    ImageModule,
    GalleriaModule,
    ReactiveFormsModule
  ],
  exports: [
    InputTextModule,
    ButtonModule,
    MenubarModule,
    PanelMenuModule,
    MegaMenuModule,
    CardModule,
    primeSharedModule,
    RippleModule,
    FooterComponent,
    DialogModule,
    CarouselModule,
    ImageModule,
    GalleriaModule,
    ReactiveFormsModule
  ]
})
export class SharedModule { }
